import React, { Component } from 'react'
import { connect } from 'react-redux'
import classes from './JewelsToolbar.module.scss';

import { setLength } from '../../../redux/jewels/actions';

import { SimpleSelect } from '../../../common'

class JewelsToolbar extends Component {

  handleClick = (value) =>{
    this.props.setDisplayType(value)
  }

  handleLengthChange = (event) =>{
    this.props.setLength(event.target.value);
  }

  render() {
    const lengthoptions = [
        {value:4, label:4},
        {value:8, label:8},
        {value:12, label:12},
        {value:24, label:24},
        {value:48, label:48},
        {value:96, label:96},
        {value:192, label:192}
      ];

      return(
          <div className={classes.Toolbar}>
            <div>{this.props.total} items</div>
            <div><SimpleSelect onChange={this.handleLengthChange} value={this.props.length} options={lengthoptions}>results per page</SimpleSelect></div>
          </div>
      );
  }
}

const mapStateToProps = (state)=>{
  return {
    total: state.jewels.total,
    length:state.jewels.length
  }
};

export default connect(mapStateToProps, {setLength})(JewelsToolbar);